export default __webpack_public_path__ + "static/media/Dudas.067ecdef.svg";